import type { Movement } from '#src/app/pages/petitionDetails/shared/types';

import { usePetitionDetails } from '../petitionDetails';

export function useFirstMovement(): Movement | undefined {
	const { movements } = usePetitionDetails();

	return movements.nodes[0];
}
